/* The value for MODAL_CLOSE_TIMEOUT should be the same as $modal-transition-duration in SCSS */
const MODAL_CLOSE_TIMEOUT = 200;

export {MODAL_CLOSE_TIMEOUT};
